import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import "./CustomTextareaAutosize.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CustomTextareaAutosize({
  value,
  onChangeValue,
  label,
  fieldKey,
  placeholder,
  minRows = 4,
  maxRows = 8,
  icon,
  error,
  style = {},
}) {
  const classes = useStyles();

  return (
    <div className="shared-dexter-custom-textarea" style={style}>
      {icon && <img src={icon} alt={label} />}

      <div className="textarea-container">
        {label && <div className="textarea-label">{label}</div>}

        <TextareaAutosize
          minRows={minRows}
          maxRows={maxRows}
          value={value}
          placeholder={placeholder || label}
          onChange={(e) =>
            onChangeValue({
              target: { key: fieldKey, value: e.target.value },
            })
          }
          className={error ? "error" : ""}
        />

        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
}
